<div class="container-header" *ngIf="isHeaderVisible()">
  <div class="container-icon" *ngIf="icon">
    <app-icon [icon]="icon"></app-icon>
  </div>
  <div class="container-titles">
    <span class="container-title">{{ title }}</span>
    <span class="container-subtitle" *ngIf="subtitle">{{ subtitle }}</span>
  </div>
</div>
